export default __webpack_public_path__ + "static/media/ai4.00627316.png";